const ASSETS = "https://customer-assets-eiarnc6j.emergentagent.net/job_legal-studio-14/artifacts";

export const TEAM = [
  {
    id: "giuseppe-brunetti",
    initials: "GB",
    name: "Giuseppe Brunetti",
    role: "Socio",
    items: ["Diritto penale", "Diritto di famiglia", "Successioni"],
    bio: "Da venticinque anni si occupa di diritto familiare e penale, nonché di successioni e patti di famiglia.",
    img: `${ASSETS}/27ymz5zd_image_20260930_172700-cambia-la-cravatta-in-rossa-cambia-la-camicia-in-bianca-meno-sorridente-metti.webp`,
  },
  {
    id: "vincenzo-simone-depasquale",
    initials: "VD",
    name: "Vincenzo Simone Depasquale",
    role: "Socio",
    items: ["Diritto del lavoro", "Diritto tributario e fiscale"],
    bio: "Già direttore di un primario gruppo imprenditoriale nel settore agroalimentare, è a capo del dipartimento immobiliare, fiscale, tributario e giuslavoristico, assistendo privati ed imprese anche nell'analisi dei bilanci e dei rapporti con fornitori e lavoratori.",
    img: `${ASSETS}/8tgjwo20_WhatsApp%20Image%202026-09-30%20at%2012.02.01.jpeg`,
  },
  {
    id: "francesco-del-prete",
    initials: "FD",
    name: "Francesco Del Prete",
    role: "Socio",
    items: ["Diritto bancario e finanziario", "Diritto pensionistico"],
    bio: "Esperto di diritto bancario e finanziario, assiste privati ed imprese; esperto anche in diritto previdenziale pubblico, assistendo gli interessati nel riconoscimento della causa di servizio ed i conseguenti benefici.",
    img: `${ASSETS}/gqmsfc7y_81173-cambia-lo-sfondo-e-adegualo-ad-uno-studio-legale.jpg`,
  },
  {
    id: "michela-sansonetti",
    initials: "MS",
    name: "Michela Sansonetti",
    role: "Partner",
    items: ["Recupero crediti", "Responsabilità extracontrattuale"],
    img: `${ASSETS}/tighz9mm_WhatsApp%20Image%202026-09-30%20at%2017.51.39-migliora-la-foto-per-pubblicarla-sul-sito-di-uno-s-riduci-le-o%20%282%29.jpg`,
  },
  {
    id: "marika-antonucci",
    initials: "MA",
    name: "Marika Antonucci",
    role: "Partner",
    items: ["Diritto bancario", "Infortunistica"],
    img: `${ASSETS}/68vqmw4k_image_20260930_175158.jpg`,
  },
  {
    id: "valeria-mustica",
    initials: "VM",
    name: "Valeria Mustica",
    role: "Partner",
    items: ["Diritto condominiale", "Diritto patrimoniale"],
    img: `${ASSETS}/021dffie_WhatsApp%20Image%202026-09-30%20at%2017.43.46-modifica-questa-foto-per-pubblicare-sul-nostro-sit-mettila-sed%20%281%29.jpg`,
  },
  {
    id: "luisiana-forleo",
    initials: "LF",
    name: "Luisiana Forleo",
    role: "Segreteria",
    items: ["Segreteria", "Rapporti con i clienti", "Preparazione del fascicolo"],
    img: `${ASSETS}/brbjrdki_WhatsApp%20Image%202026-09-30%20at%2017.16.03-lasciala-seduta-dietro-la-scrivania-togli-il-neo-dal-naso%20%282%29.jpg`,
  },
  {
    id: "eleonora-calo",
    initials: "EC",
    name: "Eleonora Calò",
    role: "Segreteria",
    items: ["Segreteria", "Rapporti con i clienti", "Preparazione del fascicolo"],
    img: `${ASSETS}/u1a0m5zb_WhatsApp%20Image%202026-09-30%20at%2018.28.54.jpeg`,
  },
];
